import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OriginalLayoutComponent } from './original-layout.component';
import { DialogModule } from 'primeng/dialog';
import { SharedModule } from '@feature/_app_modules/shared/shared.module';
import { ActivityRecorderComponent } from '@activity-recorder/components/activity-recorder.component';
import { DesktopAlertModule } from '@feature/_app_modules/desktop-alert/desktop-alert.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    OriginalLayoutComponent,
    ActivityRecorderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DialogModule,
    DesktopAlertModule,
    RouterModule
  ],
  exports: [
    OriginalLayoutComponent,
    ActivityRecorderComponent,
  ]
})
export class OriginalLayoutModule { }
